const REF_KEY = "marketing_ref";
const PROMO_KEY = "marketing_promo";

function normalizeValue(value) {
  if (typeof value !== "string") return "";
  const v = value.trim();
  return v || "";
}

export function persistMarketingParamsFromSearch(search) {
  const raw = typeof search === "string" ? search : "";
  if (!raw) return;

  const params = new URLSearchParams(raw);
  const ref = normalizeValue(params.get("ref"));
  const promo = normalizeValue(params.get("promo"));

  if (!ref && !promo) return;

  try {
    if (ref) localStorage.setItem(REF_KEY, ref);
    if (promo) localStorage.setItem(PROMO_KEY, promo);
  } catch (e) {
    // ignore storage errors
  }
}

export function getStoredMarketingParams() {
  try {
    const ref = normalizeValue(localStorage.getItem(REF_KEY));
    const promo = normalizeValue(localStorage.getItem(PROMO_KEY));
    return { ref, promo };
  } catch (e) {
    return { ref: "", promo: "" };
  }
}
